import React from 'react';
import { AppSmith } from '../../components/appsmith/appsmith';

export function ScheduleCrawl(props) {
  return (
    <AppSmith title="Schedule a Crawl" pageId="6172efa4515e45415cc7f528" />
  );
}
